



































import { Vue, Component, Prop } from "vue-property-decorator";
import { AxiosResponse } from "axios";
import { namespace } from "vuex-class";
import { StripeCreditCard } from "../types";

const Subscription = namespace("subscriptions");

@Component({})
export default class CreditCardTable extends Vue {
  @Subscription.Action("fetchAllCards")
  fetchAllCards!: () => Promise<AxiosResponse>;
  @Subscription.Action("deleteCard")
  deleteCard!: (cardId: string) => Promise<void>;
  @Subscription.Getter("getAllCreditCards") creditCards: StripeCreditCard[];
  @Prop({ default: false }) readonly showSelectCardColumn: boolean;
  @Prop() readonly switchCard: (
    card: StripeCreditCard,
    showNotification?: boolean
  ) => void;
  @Prop() readonly selectedCard: StripeCreditCard;

  async created() {
    // Set the default card as the default selected card
    const response = await this.fetchAllCards();
    if (response.data) {
      const result = response.data.data.filter((card) => card.default === true);
      if (result) {
        if (result[0]) this.switchCard(result[0], false);
      }
    }
  }
  async handleDeleteCard(cardId: string) {
    try {
      const confirmed = window.confirm(
        `Are you sure you want to delete the card?`
      );
      if (confirmed) {
        await this.deleteCard(cardId);
      }
    } catch (error) {
      console.log(error);
    }
  }
}
